import { Vue, Component, Emit } from 'vue-property-decorator'

@Component
export default class PreformattedEditorActionClearTemplates extends Vue {
    @Emit()
    clean(): boolean {
        return true
    }
}
